import React from "react";

const InfoCard = props => {
    const {title, description} = props;

    return (
        <div className="overview-card">
            <span className="overview-card--title"> {title} </span>
            <span className="overview-card--description"> {description} </span>
        </div>
    );
};
export default InfoCard;
